import React, { FC, useContext } from 'react'
import { ToolbarButton } from '@/components/toolbar/atoms'
import { ToolbarElementProps } from '@/model/Toolbar'
import { EditorConfigContext } from '@/context'
import styles from './UndoGroup.module.scss'
import { platformShortCutLabel } from '@/utils/platform.utils'

export const UndoGroup: FC<ToolbarElementProps> = ({ editor }) => {
  const { tools } = useContext(EditorConfigContext)

  const handleUndo = () => editor.chain().focus().undo().run()
  const handleRedo = () => editor.chain().focus().redo().run()

  const canUndo = editor.can().chain().focus().undo().run()
  const canRedo = editor.can().chain().focus().redo().run()

  const display = tools.includes('undo')

  return display ? (
    <div className={styles['container']}>
      <ToolbarButton
        title={`Annuler (${platformShortCutLabel('$CTRL + Z')})`}
        icon="Undo"
        onClick={handleUndo}
        disabled={!canUndo}
        testId="button-toolbar-editor-undo"
      />
      <ToolbarButton
        title={`Rétablir (${platformShortCutLabel('$CTRL + Y')})`}
        icon="Redo"
        onClick={handleRedo}
        disabled={!canRedo}
        testId="button-toolbar-editor-redo"
      />
    </div>
  ) : null
}
